/* ============================================================
 * RoyalChicByPriti — FOMO / Urgency Suite
 * Replaces 3rd-party LastHour-PVC app with brand-styled native:
 *   - Real inventory urgency ("Only X left")
 *   - Dispatch countdown (always positive framing, never deters)
 *   - Recent purchase popups (rotated, real products)
 *   - Live viewer counter (semi-randomized, session-stable)
 * ============================================================ */
(function () {
  'use strict';

  var FOMO = {
    inventory_urgency: true,
    dispatch_countdown: true,
    recent_purchases: true,
    viewer_counter: true,
    recent_purchases_max: 3,
    recent_purchases_interval_ms: 55000,
    cutoff_hour_ist: 17  // 5 PM IST cutoff for same-day dispatch
  };

  var NAMES = [
    'Priya', 'Anjali', 'Sneha', 'Kavita', 'Meera', 'Sunita',
    'Pooja', 'Riya', 'Aisha', 'Neha', 'Divya', 'Rashi',
    'Tanvi', 'Shreya', 'Sanya', 'Ritika', 'Nisha', 'Komal',
    'Bhavna', 'Aarti', 'Vidya', 'Mansi', 'Simran', 'Rekha'
  ];
  var CITIES = [
    'Mumbai', 'Delhi', 'Bangalore', 'Pune', 'Hyderabad', 'Chennai',
    'Kolkata', 'Jaipur', 'Ahmedabad', 'Lucknow', 'Noida', 'Gurgaon',
    'Surat', 'Chandigarh', 'Indore', 'Bhopal', 'Kanpur', 'Nagpur',
    'Vadodara', 'Coimbatore', 'Patna', 'Visakhapatnam'
  ];

  function isProductPage() {
    return document.body.classList.contains('template-product') ||
           window.location.pathname.indexOf('/products/') === 0;
  }

  function randInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function pickRandom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function readProductData() {
    var data = { title: '', handle: '', inventory: null, onSale: false, salePct: 0 };
    try {
      var jsonScripts = document.querySelectorAll('script[type="application/json"][id*="ProductJson"], script[type="application/json"][data-product-json]');
      for (var i = 0; i < jsonScripts.length; i++) {
        try {
          var pj = JSON.parse(jsonScripts[i].textContent);
          if (pj && pj.title) {
            data.title = pj.title;
            data.handle = pj.handle || '';
            data.onSale = !!(pj.compare_at_price_min && pj.price_min && pj.compare_at_price_min > pj.price_min);
            if (data.onSale) {
              data.salePct = Math.round((1 - (pj.price_min / pj.compare_at_price_min)) * 100);
            }
            if (pj.variants && pj.variants.length) {
              var totalInv = 0;
              var hasData = false;
              for (var v = 0; v < pj.variants.length; v++) {
                if (typeof pj.variants[v].inventory_quantity === 'number') {
                  totalInv += pj.variants[v].inventory_quantity;
                  hasData = true;
                }
              }
              if (hasData) data.inventory = totalInv;
            }
            break;
          }
        } catch (e) { continue; }
      }
      if (!data.title) {
        var ogt = document.querySelector('meta[property="og:title"]');
        if (ogt) data.title = ogt.getAttribute('content');
      }
      if (!data.handle) {
        var p = window.location.pathname.split('/products/')[1];
        if (p) data.handle = p.split(/[?#]/)[0];
      }
      if (!data.onSale) {
        data.onSale = !!document.querySelector('.price--on-sale, .price__sale .price-item--last');
      }
    } catch (e) {}
    return data;
  }

  // ---------- 1. Inventory Urgency Badge ----------
  function mountInventoryUrgency(product) {
    if (!FOMO.inventory_urgency) return;
    if (product.inventory === null || product.inventory === undefined) return;
    if (product.inventory > 10 || product.inventory < 1) return;

    var badge = document.createElement('div');
    badge.className = 'rc-fomo-inventory';
    var msg;
    if (product.inventory === 1) {
      msg = '⚡ Only 1 piece left — hurry!';
      badge.classList.add('rc-fomo-inventory--last');
    } else if (product.inventory <= 3) {
      msg = '🔥 Only ' + product.inventory + ' left in stock';
      badge.classList.add('rc-fomo-inventory--low');
    } else {
      msg = '✨ ' + product.inventory + ' available — selling fast';
    }
    badge.textContent = msg;

    var anchor = document.querySelector('product-form') ||
                 document.querySelector('form[action*="/cart/add"]');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(badge, anchor);
    }
  }

  // ---------- 2. Dispatch Countdown (always positive, always counting) ----------
  function mountDispatchCountdown() {
    if (!FOMO.dispatch_countdown) return;

    var widget = document.createElement('div');
    widget.className = 'rc-fomo-countdown';
    widget.innerHTML = [
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
      '<div class="rc-fomo-countdown__text">',
      '  <strong class="rc-fomo-countdown__label">Order in</strong>',
      '  <span class="rc-fomo-countdown__time">--:--:--</span>',
      '  <span class="rc-fomo-countdown__suffix">for same-day dispatch</span>',
      '</div>'
    ].join('');

    var anchor = document.querySelector('product-form') ||
                 document.querySelector('form[action*="/cart/add"]');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(widget, anchor);
    }

    function tick() {
      var now = new Date();
      var utcMs = now.getTime() + (now.getTimezoneOffset() * 60000);
      var ist = new Date(utcMs + (330 * 60000));

      var todayCutoff = new Date(ist);
      todayCutoff.setHours(FOMO.cutoff_hour_ist, 0, 0, 0);

      var endOfDay = new Date(ist);
      endOfDay.setHours(24, 0, 0, 0);  // tomorrow's midnight = today's end

      var timeEl = widget.querySelector('.rc-fomo-countdown__time');
      var labelEl = widget.querySelector('.rc-fomo-countdown__label');
      var suffixEl = widget.querySelector('.rc-fomo-countdown__suffix');

      timeEl.style.display = '';
      widget.classList.remove('rc-fomo-countdown--past');

      var diff;
      if (ist < todayCutoff) {
        // Before 5 PM — same-day dispatch urgency
        labelEl.textContent = 'Order in';
        suffixEl.textContent = 'for same-day dispatch';
        diff = todayCutoff.getTime() - ist.getTime();
      } else {
        // After 5 PM — "Order today in X to ship by tomorrow"
        labelEl.textContent = 'Order today in';
        suffixEl.textContent = 'to ship by tomorrow';
        diff = endOfDay.getTime() - ist.getTime();
      }

      var hrs = Math.floor(diff / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      timeEl.textContent = pad(hrs) + ':' + pad(mins) + ':' + pad(secs);
    }

    tick();
    setInterval(tick, 1000);
  }

  // ---------- 3. Viewer Counter ----------
  function mountViewerCounter(product) {
    if (!FOMO.viewer_counter) return;

    var sessKey = 'rc_viewer_' + (product.handle || 'unknown');
    var count;
    try {
      var stored = sessionStorage.getItem(sessKey);
      if (stored) {
        count = parseInt(stored, 10);
      } else {
        count = randInt(4, 11);
        sessionStorage.setItem(sessKey, String(count));
      }
    } catch (e) {
      count = randInt(4, 11);
    }

    var widget = document.createElement('div');
    widget.className = 'rc-fomo-viewers';
    widget.innerHTML = [
      '<span class="rc-fomo-viewers__dot"></span>',
      '<span class="rc-fomo-viewers__count">' + count + '</span>',
      '<span class="rc-fomo-viewers__label">others viewing now</span>'
    ].join('');

    var anchor = document.querySelector('.product__title') ||
                 document.querySelector('.product-meta') ||
                 document.querySelector('product-form');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(widget, anchor);
    }

    setInterval(function () {
      var delta = pickRandom([-1, 0, 0, 1]);
      count = Math.max(2, Math.min(15, count + delta));
      try { sessionStorage.setItem(sessKey, String(count)); } catch (e) {}
      widget.querySelector('.rc-fomo-viewers__count').textContent = count;
    }, 30000);
  }

  // ---------- 4. Recent Purchase Popups ----------
  function mountRecentPurchases() {
    if (!FOMO.recent_purchases) return;

    var shown = 0;
    var maxShown = FOMO.recent_purchases_max;
    var products = [];

    fetch('/products.json?limit=30')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.products) {
          products = data.products
            .filter(function (p) { return p.title && p.handle; })
            .map(function (p) {
              return {
                title: p.title,
                handle: p.handle,
                image: (p.images && p.images[0]) ? p.images[0].src : null
              };
            });
        }
      })
      .catch(function () {});

    function show() {
      if (shown >= maxShown) return;
      if (!products.length) {
        setTimeout(show, 8000);
        return;
      }

      var prod = pickRandom(products);
      var name = pickRandom(NAMES);
      var city = pickRandom(CITIES);
      var minsAgo = randInt(2, 18);

      var toast = document.createElement('a');
      toast.className = 'rc-fomo-toast';
      toast.href = '/products/' + prod.handle;
      toast.setAttribute('aria-label', name + ' from ' + city + ' just ordered ' + prod.title);
      toast.innerHTML = [
        prod.image ? '<img class="rc-fomo-toast__img" src="' + prod.image + '" alt="" loading="lazy">' : '<div class="rc-fomo-toast__img rc-fomo-toast__img--placeholder"></div>',
        '<div class="rc-fomo-toast__body">',
        '  <strong class="rc-fomo-toast__name">' + name + ' from ' + city + '</strong>',
        '  <span class="rc-fomo-toast__action">just ordered <em>' + prod.title.replace(/[<>]/g, '') + '</em></span>',
        '  <time class="rc-fomo-toast__time">' + minsAgo + ' minutes ago</time>',
        '</div>',
        '<button type="button" class="rc-fomo-toast__close" aria-label="Close">&times;</button>'
      ].join('');

      document.body.appendChild(toast);
      requestAnimationFrame(function () { toast.classList.add('rc-fomo-toast--open'); });

      var dismiss = function (e) {
        if (e) { e.preventDefault(); e.stopPropagation(); }
        toast.classList.remove('rc-fomo-toast--open');
        setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 250);
      };
      toast.querySelector('.rc-fomo-toast__close').addEventListener('click', dismiss);
      setTimeout(dismiss, 6000);

      shown++;
      if (shown < maxShown) {
        setTimeout(show, FOMO.recent_purchases_interval_ms + randInt(-8000, 8000));
      }
    }

    setTimeout(show, 12000);
  }

  // ---------- Init ----------
  function init() {
    if (!isProductPage()) {
      mountRecentPurchases();
      return;
    }
    var product = readProductData();
    mountInventoryUrgency(product);
    mountDispatchCountdown();
    mountViewerCounter(product);
    mountRecentPurchases();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
